module.exports = __webpack_public_path__ + "img/bookmarks.7d046fc4.svg";